/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {DataAutomationPipeline} from './DataAutomationPipeline';
import {DataAutomationRun} from './DataAutomationRun';
import {DataAutomationRunResult} from './DataAutomationRunResult';

/**
 * The DataAutomationPipelineRun model module.
 * @module model/DataAutomationPipelineRun
 * @version 1.0.0
 */
export class DataAutomationPipelineRun {
  /**
   * Constructs a new <code>DataAutomationPipelineRun</code>.
   * @alias module:model/DataAutomationPipelineRun
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DataAutomationPipelineRun</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DataAutomationPipelineRun} obj Optional instance to populate.
   * @return {module:model/DataAutomationPipelineRun} The populated <code>DataAutomationPipelineRun</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DataAutomationPipelineRun();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('dataAutomationPipeline'))
        obj.dataAutomationPipeline = DataAutomationPipeline.constructFromObject(data['dataAutomationPipeline']);
      if (data.hasOwnProperty('state'))
        obj.state = ApiClient.convertToType(data['state'], 'String');
      if (data.hasOwnProperty('startDate'))
        obj.startDate = ApiClient.convertToType(data['startDate'], 'String');
      if (data.hasOwnProperty('endDate'))
        obj.endDate = ApiClient.convertToType(data['endDate'], 'String');
      if (data.hasOwnProperty('dataAutomationRuns'))
        obj.dataAutomationRuns = ApiClient.convertToType(data['dataAutomationRuns'], [DataAutomationRun]);
      if (data.hasOwnProperty('result'))
        obj.result = DataAutomationRunResult.constructFromObject(data['result']);
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
DataAutomationPipelineRun.prototype._id = undefined;

/**
 * @member {module:model/DataAutomationPipeline} dataAutomationPipeline
 */
DataAutomationPipelineRun.prototype.dataAutomationPipeline = undefined;

/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */
DataAutomationPipelineRun.StateEnum = {
  /**
   * value: "started"
   * @const
   */
  started: "started",

  /**
   * value: "running"
   * @const
   */
  running: "running",

  /**
   * value: "done"
   * @const
   */
  done: "done"
};
/**
 * @member {module:model/DataAutomationPipelineRun.StateEnum} state
 */
DataAutomationPipelineRun.prototype.state = undefined;

/**
 * @member {String} startDate
 */
DataAutomationPipelineRun.prototype.startDate = undefined;

/**
 * @member {String} endDate
 */
DataAutomationPipelineRun.prototype.endDate = undefined;

/**
 * @member {Array.<module:model/DataAutomationRun>} dataAutomationRuns
 */
DataAutomationPipelineRun.prototype.dataAutomationRuns = undefined;

/**
 * @member {module:model/DataAutomationRunResult} result
 */
DataAutomationPipelineRun.prototype.result = undefined;

/**
 * @member {String} created
 */
DataAutomationPipelineRun.prototype.created = undefined;

/**
 * @member {String} updated
 */
DataAutomationPipelineRun.prototype.updated = undefined;

